import React from 'react';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Divider from '@mui/material/Divider';

export const FieldSettings = () => {
	return (
		<>
			<Toolbar>
				<span>Manage Fields</span>
			</Toolbar>
			<Divider />
			<Box sx={{ pl: 3 }}>
				<p>Manage Fields</p>
			</Box>
		</>
	);
};
